<template>
  <div class="policy-page pk-account-panel">
    <section class="policy-hero about-hero">
      <div>
        <span>{{ about.eyebrow }}</span>
        <h1>{{ about.title }}</h1>
        <p>{{ about.lead }}</p>
      </div>
      <div class="hero-mark">
        <img src="../assets/hotpizza/pizzaking-logo.svg" alt="pizzaking" />
      </div>
    </section>

    <section class="stats-strip">
      <article v-for="item in stats" :key="item.label">
        <strong>{{ item.value }}</strong>
        <span>{{ item.label }}</span>
      </article>
    </section>

    <section class="policy-card">
      <div class="card-title">
        <span>{{ about.sectionEyebrow }}</span>
        <h2>{{ about.sectionTitle }}</h2>
      </div>
      <div class="about-grid">
        <article v-for="item in about.points" :key="item.title">
          <b>{{ item.title }}</b>
          <p>{{ item.text }}</p>
        </article>
      </div>
    </section>

    <section class="contact-card">
      <span>{{ about.contactEyebrow }}</span>
      <h2>{{ about.contactTitle }}</h2>
      <p>{{ about.contactText }}</p>
      <button @click="$router.push('/Doubt')">常见问题</button>
      <button class="cooperation-btn" @click="$router.push('/Doubt?category=cooperation')">客服中心</button>
    </section>
  </div>
</template>

<script>
import { cloneSiteContent, loadSiteContent } from "@/services/siteContent";

export default {
  data() {
    return {
      siteStats: {
        openbox_num: 0,
        player_num: 0,
        online_num: 0,
      },
      statsTimer: null,
      about: cloneSiteContent("about"),
    };
  },
  computed: {
    stats() {
      return [
        { value: this.formatStat(this.siteStats.openbox_num), label: "累计打开箱子" },
        { value: this.formatStat(this.siteStats.player_num), label: "已注册玩家" },
        { value: this.formatStat(this.siteStats.online_num), label: "当前在线" },
        { value: "60 秒", label: "统计刷新周期" },
      ];
    },
  },
  mounted() {
    this.loadStats();
    loadSiteContent(this.$axios).then((content) => {
      this.about = content.about;
    });
    this.statsTimer = window.setInterval(this.loadStats, 60000);
    this.$root.$on("online-count-update", this.updateOnlineCount);
  },
  beforeDestroy() {
    window.clearInterval(this.statsTimer);
    this.$root.$off("online-count-update", this.updateOnlineCount);
  },
  methods: {
    updateOnlineCount(value) {
      this.$set(this.siteStats, "online_num", Number(value || 0));
    },
    loadStats() {
      this.$axios.post("/index/Login/logininfo", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.siteStats = res.data.data;
        }
      });
    },
    formatStat(value) {
      return Number(value || 0).toLocaleString("en-US");
    },
  },
};
</script>

<style lang="less" scoped>
.policy-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 96px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 138, 31, 0.16), transparent 32%),
    radial-gradient(circle at 86% 20%, rgba(0, 217, 255, 0.08), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.policy-hero,
.stats-strip,
.policy-card,
.contact-card {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.policy-hero {
  min-height: 330px;
  padding: 44px;
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 28px;
  align-items: center;
  overflow: hidden;
  position: relative;
  border-radius: 18px;
  background:
    radial-gradient(circle at 76% 46%, rgba(255, 138, 31, 0.22), transparent 32%),
    linear-gradient(135deg, rgba(43, 46, 61, 0.98), rgba(24, 26, 36, 0.98));
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.policy-hero::after {
  content: "";
  width: 620px;
  height: 190px;
  position: absolute;
  right: -150px;
  bottom: -92px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.035);
}

.policy-hero span,
.card-title span,
.contact-card span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.policy-hero h1 {
  margin: 14px 0 16px;
  color: #f8fbff;
  font-size: 64px;
  line-height: 0.96;
  font-weight: 1000;
}

.policy-hero p,
.contact-card p,
.about-grid p {
  color: #aeb6c8;
  font-size: 16px;
  line-height: 1.75;
  font-weight: 800;
}

.hero-mark {
  min-height: 240px;
  display: grid;
  place-items: center;
  position: relative;
  z-index: 1;
  border-radius: 18px;
  background: radial-gradient(circle, rgba(255, 138, 31, 0.24), transparent 66%);
}

.hero-mark img {
  width: 250px;
  filter: drop-shadow(0 24px 40px rgba(0, 0, 0, 0.44));
}

.stats-strip {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.stats-strip article,
.policy-card,
.contact-card {
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.96), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.stats-strip article {
  min-height: 112px;
  display: grid;
  place-items: center;
  text-align: center;
}

.stats-strip strong {
  color: #ffd764;
  font-size: 30px;
  font-weight: 1000;
}

.stats-strip span {
  color: #8f98ac;
  font-size: 13px;
  font-weight: 900;
}

.policy-card,
.contact-card {
  margin-top: 22px;
  padding: 30px;
}

.card-title h2,
.contact-card h2 {
  margin: 8px 0 0;
  color: #f8fbff;
  font-size: 32px;
  font-weight: 1000;
}

.about-grid {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.about-grid article {
  min-height: 170px;
  padding: 22px;
  border-radius: 12px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
}

.about-grid b {
  color: #f5f7ff;
  font-size: 20px;
  font-weight: 1000;
}

.contact-card button {
  height: 42px;
  margin-top: 14px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
}

.contact-card .cooperation-btn {
  margin-left: 10px;
  color: #f4f6ff;
  background: #303340;
  border: 1px solid rgba(255, 194, 73, 0.32);
}

@media screen and (max-width: 1080px) {
  .policy-page {
    padding: 20px 12px 64px;
  }

  .policy-hero,
  .stats-strip,
  .about-grid {
    grid-template-columns: 1fr;
  }

  .policy-hero h1 {
    font-size: 46px;
  }
}
</style>

<style lang="less">
.policy-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(circle at 50% 0, rgba(253, 107, 1, 0.08), transparent 360px),
    #191b26 !important;
}

.policy-page.pk-account-panel .policy-hero,
.policy-page.pk-account-panel .stats-strip,
.policy-page.pk-account-panel .policy-card,
.policy-page.pk-account-panel .contact-card,
.policy-page.pk-account-panel .about-grid {
  width: 100% !important;
  max-width: none !important;
}

.policy-page.pk-account-panel .policy-hero {
  min-height: 288px !important;
  border-radius: 8px !important;
  background:
    radial-gradient(circle at 18% 50%, rgba(255, 132, 31, 0.16), transparent 280px),
    #20222f !important;
  border-color: #2b2d3c !important;
  box-shadow: none !important;
}

.policy-page.pk-account-panel .stats-strip,
.policy-page.pk-account-panel .about-grid {
  gap: 8px !important;
}

.policy-page.pk-account-panel .stats-strip article,
.policy-page.pk-account-panel .policy-card,
.policy-page.pk-account-panel .contact-card,
.policy-page.pk-account-panel .about-grid article {
  border-color: #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
  box-shadow: none !important;
}

.policy-page.pk-account-panel .about-grid article {
  min-height: 166px !important;
}
</style>

<style lang="less">
.policy-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.policy-page.pk-account-panel .policy-hero,
.policy-page.pk-account-panel .stats-strip,
.policy-page.pk-account-panel .policy-card,
.policy-page.pk-account-panel .contact-card {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.policy-page.pk-account-panel .policy-hero {
  min-height: 360px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.policy-page.pk-account-panel .hero-mark img {
  width: 290px !important;
  filter:
    drop-shadow(0 26px 42px rgba(0, 0, 0, 0.46))
    drop-shadow(0 0 24px rgba(255, 138, 0, 0.24)) !important;
}

.policy-page.pk-account-panel .stats-strip {
  gap: 16px !important;
}

.policy-page.pk-account-panel .policy-card,
.policy-page.pk-account-panel .contact-card,
.policy-page.pk-account-panel .about-grid article {
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.policy-page.pk-account-panel .about-grid {
  gap: 16px !important;
}

.policy-page.pk-account-panel .about-grid article {
  min-height: 188px !important;
}

@media screen and (max-width: 1080px) {
  .policy-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .policy-page.pk-account-panel .policy-hero,
  .policy-page.pk-account-panel .stats-strip,
  .policy-page.pk-account-panel .policy-card,
  .policy-page.pk-account-panel .contact-card {
    width: 100% !important;
  }
}
</style>
